import React from 'react';

/**
 * MFC Allocation Tool tab content
 * Tools for managing MFC-level allocations
 */
export function MFCAllocationTool({ selectedFacility }) {
    return (
        <div>
            <div className="text-lg font-medium">MFC Allocation Tool for {selectedFacility?.name}</div>
            {/* Content will be built here */}
        </div>
    );
}
